import styles from "./FiltersHeader.module.scss";
import FilterHeaderFilter from "../../../../components/icons/forYou/FilterHeaderFilter";
import { useAppSelector } from "../../../../store/store";

interface IProps {
  goToFilters: () => void
}

const FiltersButton = ({ goToFilters }: IProps) => {
  const genres = useAppSelector((state: any) => state.filters.genres)
  const period = useAppSelector((state: any) => state.filters.period)
  const maxYear = useAppSelector((state: any) => state.filters.maxYear)

  const filterCounterHandler = (gen: number[], per: number[]) => {
    let counter = 0;
    if (per[0] !== 1980 || per[1] !== maxYear) {
      counter += 1;
    };

    counter += gen.length;

    return counter;
  }

  const filtersCount = filterCounterHandler(genres, period);
  const hasSelectedFilters = filtersCount !== 0;

  return (
    <button
      type="button"
      onClick={goToFilters}
      data-tour="filters"
      className={`
        ${styles.filterButtonWrapper}
        ${hasSelectedFilters ? styles.filterButtonWrapperActive : ""}
      `}
      aria-label="Open filters"
      aria-pressed={hasSelectedFilters}
    >
      <FilterHeaderFilter className={styles.iconClass} />
      {hasSelectedFilters && <span className={styles.filtersButtonCounter}>{filtersCount}</span>}
    </button>
  )
};

export default FiltersButton;
